module.exports = __webpack_public_path__ + "img/Twitter.aeaf9a10.svg";